import React from 'react'
import Contact from './Contact'
import FooterStyle from '../styles/FooterStyle'

const Footer = () => {
  return (
    <>
      <Contact />
      <FooterStyle>
        <div className="container">
          <div id="copyright">
            <span className="bold">NIP:</span> 113-00-93-176 <br />
            <span className="bold">Adres siedziby:</span> Kamionkowska 51,
            03-812 Warszawa <br />
            <span className="bold">Numer rachunku bankowego:</span> 14 1130 1017
            0020 1019 7420 0001 <br />
            <span className="bold">KRS:</span> 0000099583, Sąd Rejonowy dla
            m.st. Warszawy w Warszawie XIII Wydział Gospodarczy KRS <br />
            <span className="bold">Wysokość kapitału zakładowego:</span> 300
            000zł.
          </div>
          <div>
            <a className="logo-raks" href="#main">
              raks
            </a>
          </div>
        </div>
      </FooterStyle>
    </>
  )
}

export default Footer
